import DoubleStat from './DoubleStat'

export default DoubleStat